import React, { Component, Fragment } from 'react'
import { Button, Switch, TextField, FormControlLabel, CircularProgress} from 'material-ui'
import Dialog, { DialogActions, DialogContent, DialogTitle} from 'material-ui/Dialog'
import { withStyles } from 'material-ui/styles'
import axios from 'axios'
import md5 from 'md5'
import request from 'superagent'
import { withCookies } from 'react-cookie'

const styles = theme => ({
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  wrapper: {
    margin: theme.spacing.unit,
    position: 'relative',
  },
});

class LogInDialog extends Component {
  state = {
    keepLogged: true,
    loading: false,
    username: "",
    password: ""
  }

  handleRegisterClick = () => {
    this.props.onRegister();
  }

  handleEnterHit = (ev) => {
    if (ev.key === 'Enter') {
      ev.preventDefault();
      this.handleLoginClick();
    }
  }

  handleLoginClick = () => {
    this.setState({
      loading: true
    });

    var username = this.props.cookies.get('keepLoggedIn') ? this.props.cookies.get('keepLoggedIn').username : this.state.username;
    var password = this.props.cookies.get('keepLoggedIn') ? this.props.cookies.get('keepLoggedIn').password : md5(this.state.password);

    request.post('https://mrgames-server.de/chatlet_masterserver/ServerScript.php')
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .send({ acc_id: username, command: "findaccount", password: password, androidversion: "web", appversion: "web" })
      .end(function(err, res) {
        var result = res.text.trim();
        if(result == "account is not existing") {
          this.props.cookies.remove('keepLoggedIn');
          this.setState({
            username: "",
            password: "",
            loading: false
          });
          this.props.onAlertOpen("Anmeldung", "Dieser Account existiert nicht.");
        } else if(result == "password wrong") {
          this.props.cookies.remove('keepLoggedIn');
          this.setState({
            password: "",
            loading: false
          });
          this.props.onAlertOpen("Anmeldung", "Das eingegebene Passwort ist falsch. Bitte noch einmal versuchen");
        } else {
          if(this.state.keepLogged) this.props.cookies.set('keepLoggedIn', {username: username, password: password});

          var acc_data = result.split("~");
          var acc_data = {
            acc_id: acc_data[0],
            username: acc_data[1],
            public_key: acc_data[2],
            image: acc_data[3],
            status: acc_data[4],
            contacts: acc_data[5],
            groups: acc_data[6],
            acc_state: acc_data[7]
          }

          if(acc_data.acc_state == "1") {
            {/* Account funktioniert normal */}
            if(acc_data.contacts != "no_contacts") {
              acc_data.contacts = acc_data.contacts.substring(1).split(";");
              var loaded_contacts = 0;
              acc_data.contacts.map(function(item, i) {
               request.post('https://mrgames-server.de/chatlet_masterserver/ServerScript.php')
                 .set('Content-Type', 'application/x-www-form-urlencoded')
                 .send({ acc_id: acc_data.acc_id, command: "getaccountinfo", contact_acc_id: item})
                 .end(function(err, res) {
                   var result = res.text.trim();
                   var c_data = result.split("~");
                   acc_data.contacts[i] = {
                     acc_id: item,
                     username: c_data[0],
                     public_key: c_data[1],
                     image: c_data[2],
                     status: c_data[3],
                     last_online: c_data[4],
                     dp_info: c_data[5],
                   }
                   loaded_contacts++;
                   if(loaded_contacts >= acc_data.contacts.length -1 && (loaded_groups >= acc_data.groups.length -1 || acc_data.groups == "no_groups")) {
                     this.props.onLogIn(acc_data);
                     this.setState({
                       username: "",
                       password: "",
                       loading: false
                     });
                   }
                 }.bind(this));
              }.bind(this))
            }

            if(acc_data.groups != "no_groups") {
              acc_data.groups = acc_data.groups.substring(1).split(";");
              var loaded_groups = 0;
              acc_data.groups.map(function(item, i) {
               request.post('https://mrgames-server.de/chatlet_masterserver/ServerScript.php')
                 .set('Content-Type', 'application/x-www-form-urlencoded')
                 .send({ acc_id: acc_data.acc_id, command: "getgroupinfo", group_id: item})
                 .end(function(err, res) {
                   var result = res.text.trim();
                   var c_data = result.split("~");
                   acc_data.groups[i] = {
                     group_id: item,
                     group_name: c_data[0],
                     subject: c_data[1],
                     public_key: c_data[2],
                     participants: c_data[3],
                     admins: c_data[4],
                     image: c_data[5],
                     creation_timestamp: c_data[6],
                     group_type: c_data[7],
                     group_state: c_data[8],
                   }
                   loaded_groups++;
                   if((loaded_contacts >= acc_data.contacts.length -1 || acc_data.contacts == "no_contacts") && loaded_groups >= acc_data.groups.length -1) {
                     this.props.onLogIn(acc_data);
                     this.setState({
                       username: "",
                       password: "",
                       loading: false
                     });
                   }
                 }.bind(this));
              }.bind(this))
            }
          } else if(acc_data.acc_state == "2") {
            {/* Account wurde gesperrt */}
            this.props.cookies.remove('keepLoggedIn');
            this.setState({
              loading: false
            });
            this.props.onAlertOpen("Anmeldung", "Der Account wurde gesperrt.");
          }
        }
      }.bind(this));
  }

  handleUsernameChange = (e) => {
    this.setState({
      username: e.target.value
    });
  }

  handlePasswordChange = (e) => {
    this.setState({
      password: e.target.value
    });
  }

  handleToggle = () => {
    this.setState({
      open: !this.state.open
    })
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  render() {
    const { classes, cookies, open} = this.props;

    if(cookies.get('keepLoggedIn') && !this.state.loading && open) this.handleLoginClick();

    return <Fragment>
      <Dialog open={open} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title" color="primary">Chatlet Web - Anmelden</DialogTitle>
        <DialogContent>
          <form autoComplete="off">
            <TextField value={this.state.username} autoFocus disabled={this.state.loading} onChange={this.handleUsernameChange} label="Benutzername / Account-ID" style={{width: 280}}/>
            <br/>
            <TextField value={this.state.password} disabled={this.state.loading}  onChange={this.handlePasswordChange} onKeyPress={this.handleEnterHit} type="password" label="Passwort" style={{width: 280, marginTop: 10}} />
            <br/>
            <FormControlLabel
              control = {
                <Switch disabled={this.state.loading} checked={this.state.keepLogged} onChange={this.handleChange('keepLogged')} color="primary" />
              }
              label="Angemeldet bleiben"/>
          </form>
        </DialogContent>
        <DialogActions>
          <Button color="primary" disabled={this.state.loading} onClick={this.handleRegisterClick}>Account erstellen</Button>
          <div className="classes.wrapper">
            <Button variant="raised" disabled={this.state.username === "" || this.state.password === "" || this.state.loading} color="primary" onClick={this.handleLoginClick}>
              Anmelden
              {this.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </Fragment>
  }
}

export default withCookies(withStyles(styles)(LogInDialog))



// WEBPACK FOOTER //
// ./src/Components/Dialogs/DialogLogIn.js